import React from "react";

// ✅ Combined default structure with labels
export const defaultStatutoryData = [
  {
    label: "PF",
    current: { employeePercent: "", workerPercent: "", deposited: "" },
    previous: { employeePercent: "", workerPercent: "", deposited: "" },
  },
  {
    label: "Gratuity",
    current: { employeePercent: "", workerPercent: "", deposited: "" },
    previous: { employeePercent: "", workerPercent: "", deposited: "" },
  },
  {
    label: "ESI",
    current: { employeePercent: "", workerPercent: "", deposited: "" },
    previous: { employeePercent: "", workerPercent: "", deposited: "" },
  },
  {
    label: "Others - Please Specify",
    current: { employeePercent: "", workerPercent: "", deposited: "" },
    previous: { employeePercent: "", workerPercent: "", deposited: "" },
  },
];

const StatutoryBenefitsTable = ({ statutorydata, setStatutoryData }) => {
  const handleChange = (index, section, field, value) => {
    const updated = [...statutorydata];
    updated[index] = {
      ...updated[index],
      [section]: {
        ...updated[index][section],
        [field]: value,
      },
    };
    setStatutoryData(updated);
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: "20px",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={headerStyle}>
              Benefits
            </th>
            <th colSpan="3" style={headerStyle}>
              FY ____
              <br />
              Current Financial Year
            </th>
            <th colSpan="3" style={headerStyle}>
              FY ____
              <br />
              Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}>
              No. of employees covered as % of total employees
            </th>
            <th style={headerStyle}>
              No. of workers covered as % of total workers
            </th>
            <th style={headerStyle}>Deducted and deposited (Y/N/N.A.)</th>
            <th style={headerStyle}>
              No. of employees covered as % of total employees
            </th>
            <th style={headerStyle}>
              No. of workers covered as % of total workers
            </th>
            <th style={headerStyle}>Deducted and deposited (Y/N/N.A.)</th>
          </tr>
        </thead>
        <tbody>
          {statutorydata.map((row, idx) => (
            <tr key={row.label}>
              <td style={{ ...cellStyle, fontWeight: "bold" }}>{row.label}</td>

              {/* Current FY */}
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.current.employeePercent}
                  onChange={(e) =>
                    handleChange(
                      idx,
                      "current",
                      "employeePercent",
                      e.target.value
                    )
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.current.workerPercent}
                  onChange={(e) =>
                    handleChange(
                      idx,
                      "current",
                      "workerPercent",
                      e.target.value
                    )
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Y/N/N.A."
                  value={row.current.deposited}
                  onChange={(e) =>
                    handleChange(idx, "current", "deposited", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              {/* Previous FY */}
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.previous.employeePercent}
                  onChange={(e) =>
                    handleChange(
                      idx,
                      "previous",
                      "employeePercent",
                      e.target.value
                    )
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Number"
                  value={row.previous.workerPercent}
                  onChange={(e) =>
                    handleChange(
                      idx,
                      "previous",
                      "workerPercent",
                      e.target.value
                    )
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cellStyle}>
                <input
                  type="text"
                  placeholder="Y/N/N.A."
                  value={row.previous.deposited}
                  onChange={(e) =>
                    handleChange(idx, "previous", "deposited", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  textAlign: "center",
  backgroundColor: "white",
  outline: "none",
};

export default StatutoryBenefitsTable;
